import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=1b458777&scoped=true"
import script from "./Campaigns.vue?vue&type=script&setup=true&lang=ts"
export * from "./Campaigns.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=1b458777&prod&scoped=true&lang=css"
import style1 from "./Campaigns.vue?vue&type=style&index=1&id=1b458777&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b458777",
  null
  
)

export default component.exports